import type { Dictionary } from './en'

export const nl = {
  nav: { features: 'Functies', pricing: 'Prijs', faq: 'Vragen', account: 'Mijn account', signIn: 'Inloggen' },
  hero: {
    title: 'Alt-Tab voor je Mac',
    tagline: 'macOS wisselt van app. AppSwitch laat ⌥Tab van venster wisselen — al je vensters, ook de drie documenten in dezelfde app.',
    download: 'Download voor Mac', seePricing: 'Bekijk de prijs',
    note: 'Gratis · macOS 15 of nieuwer · Apple silicon en Intel',
    hint: 'Houd ⌥ ingedrukt en druk op Tab — loslaten om te wisselen',
  },
  features: {
    heading: 'Voor wie twintig vensters open heeft',
    sub: 'Eén druk op ⌥Tab toont ze allemaal. Loslaten en je bent er.',
    items: [
      { title: 'Elk venster, niet elke app', body: 'De wisselaar van macOS wisselt tussen apps. AppSwitch wisselt tussen vensters — ook de drie documenten in dezelfde app.' },
      { title: 'Toetsenbord eerst', body: '⌥Tab vooruit, ⌥⇧Tab terug, pijltoetsen door het raster. Laat ⌥ los en het gekozen venster komt naar voren.' },
      { title: 'Steelt nooit de focus', body: 'Je app blijft actief tot je echt kiest. AppSwitch woont in de menubalk, zonder Dock-symbool in de weg.' },
      { title: 'Live voorbeelden', body: 'Zie de echte inhoud van elk venster in plaats van een algemeen app-symbool. Geminimaliseerde vensters staan gewoon in de wisselaar.' },
    ],
  },
  pricing: {
    heading: 'Eén keer kopen. Van jou.',
    sub: 'De wisselaar zelf is gratis en compleet — geen proefversie, niets uitgekleed. Pro voegt de twee functies toe die een licentie nodig hebben.',
    free: 'Gratis', pro: 'Pro', ribbon: 'Eenmalige aankoop',
    freePrice: '€0', once: 'eenmalig',
    freeSub: 'Alles om te stoppen met ⌘Tab.',
    proSub: 'Geen abonnement. Niets wordt ooit verlengd.',
    freeList: ['Volledige venesterwisselaar op ⌥Tab', 'Bediening met toetsenbord en muis', 'Raster- en lijstweergave', 'Menubalk-app, geen Dock-symbool'],
    proList: ['Alles uit de gratis versie', 'Live voorbeelden van elk venster', 'Geminimaliseerde vensters in de wisselaar', 'Twee Macs per licentie'],
    download: 'Download', buy: 'Koop AppSwitch Pro', buyBusy: 'Afrekenen wordt geopend…',
    freeFoot: 'Geen account. Geen kaart. Geen vervaldatum.',
  },
  faq: {
    heading: 'Vragen',
    items: [
      { q: 'Waarom heeft AppSwitch Toegankelijkheid nodig?', a: 'Alleen zo laat macOS een app ⌥Tab onderscheppen vóór alle andere, je vensters opsommen en er één naar voren halen. Zonder werkt de app helemaal niet. Je geeft de toegang zelf in Systeeminstellingen en kunt die altijd intrekken.' },
      { q: 'Is dit een abonnement?', a: 'Nee. AppSwitch Pro is een eenmalige aankoop. Niets wordt verlengd, niets opnieuw afgeschreven, en updates binnen de huidige hoofdversie zitten erbij.' },
      { q: 'Op hoeveel Macs mag ik het gebruiken?', a: 'Twee per licentie. Je kunt altijd een plek vrijmaken via je account of in de app, dus van machine wisselen is nooit een supportvraag.' },
      { q: 'Worden mijn venstertitels ergens heen gestuurd?', a: 'Nee. Geen vensterinhoud, geen venstertitel en geen toetsaanslag verlaat je Mac. Het enige netwerkverzoek is de licentiecontrole, en alleen als je Pro kocht. De gratis versie gebruikt het netwerk nooit.' },
      { q: 'Welke macOS-versies worden ondersteund?', a: 'macOS 15 of nieuwer, op Apple silicon en Intel.' },
    ],
  },
  listMode: {
    heading: 'Twee manieren om je vensters te zien',
    sub: 'Wisselen doe je via de menubalk, of met de toets , terwijl de wisselaar open staat.',
    grid: { title: 'Raster, met voorbeelden', body: 'Miniaturen van de echte vensterinhoud. Ideaal als je een venster herkent aan wat erin staat.' },
    list: { title: 'Lijst, met volledige titels', body: 'Eén dichte kolom waarin de hele titel van elk venster past. Ideaal voor twintig terminals, of bestanden waarvan de namen pas aan het eind verschillen.' },
  },

  footer: { terms: 'Gebruiksvoorwaarden', privacy: 'Privacybeleid' },
  consent: {
    text: 'We gebruiken Google Analytics om te zien welke pagina’s nuttig zijn. Zonder jouw toestemming wordt niets gemeten. Zie ons',
    privacyLink: 'privacybeleid', accept: 'Accepteren', decline: 'Weigeren',
  },
} satisfies Dictionary
